import { Routes } from '@angular/router';
import { AuthenticationGuard } from '@softline/auth';
import { SOFTLINE_FILTER_WWS_ABC_ANALYSIS } from './abc-analysis.api';
import { SOFTLINE_PERMISSION_WWS_ABC_ANALYSIS } from './abc-analysis.shared';
import { abcAnalysisFilter } from './types/abc-analysis-query.filter';
import { AbcAnalysisBaseMeasuresRepository } from './repositories/abc-analysis-base-measures.repository';
import { AbcAnalysisColumnsRepository } from './repositories/abc-analysis-columns.repository';
import { AbcAnalysisConfigurationsRepository } from './repositories/abc-analysis-configurations.repository';
import { AbcAnalysisProductColumnsRepository } from './repositories/abc-analysis-product-columns.repository';
import { AbcAnalysisSegmentsRepository } from './repositories/abc-analysis-segments.repository';
import { AbcAnalysisBaseMeasuresService } from './services/abc-analysis-base-measures.service';
import { AbcAnalysisColumnsService } from './services/abc-analysis-columns.service';
import { AbcAnalysisConfigurationsService } from './services/abc-analysis-configurations.service';
import { AbcAnalysisFilterDataSourceService } from './services/abc-analysis-filter-data-source.service';
import { AbcAnalysisFilterStateService } from './services/abc-analysis-filter-state.service';
import { AbcAnalysisFilterUrlSyncService } from './services/abc-analysis-filter-url-sync.service';
import { AbcAnalysisOverviewDataService } from './services/abc-analysis-overview-data.service';
import { AbcAnalysisOverviewGridService } from './services/abc-analysis-overview-grid.service';
import { AbcAnalysisProductColumnsService } from './services/abc-analysis-product-columns.service';
import { AbcAnalysisProductDetailGridService } from './services/abc-analysis-product-detail-grid.service';
import { AbcAnalysisProductDetailService } from './services/abc-analysis-product-detail.service';
import { AbcAnalysisSegmentsService } from './services/abc-analysis-segments.service';

export const abcAnalysisRoutes: Routes = [
  {
    path: 'wws-abc-analysis',
    canActivate: [AuthenticationGuard],
    data: { permission: SOFTLINE_PERMISSION_WWS_ABC_ANALYSIS },
    providers: [
      AbcAnalysisBaseMeasuresRepository,
      AbcAnalysisBaseMeasuresService,
      AbcAnalysisConfigurationsRepository,
      AbcAnalysisConfigurationsService,
      AbcAnalysisSegmentsRepository,
      AbcAnalysisSegmentsService,
      AbcAnalysisColumnsRepository,
      AbcAnalysisColumnsService,
      AbcAnalysisProductColumnsRepository,
      AbcAnalysisProductColumnsService,
      AbcAnalysisProductDetailGridService,
      // Route-scoped (not component-scoped) so `main` and `segment/:segment` share one filter
      // state instead of losing it on every drill-down navigation. The grid repository is
      // shared too, but `main` (grouped/aggregated overview, via AbcAnalysisOverviewDataService)
      // and `segment/:segment` (raw per-article rows, via AbcAnalysisSegmentArticlesDataSource)
      // each fetch their own data.
      AbcAnalysisOverviewGridService,
      AbcAnalysisFilterStateService,
      AbcAnalysisFilterDataSourceService,
      {
        provide: SOFTLINE_FILTER_WWS_ABC_ANALYSIS,
        useFactory: () => abcAnalysisFilter(),
      },
      AbcAnalysisFilterUrlSyncService,
      AbcAnalysisOverviewDataService,
    ],
    children: [
      { path: '', redirectTo: 'main', pathMatch: 'full' },
      {
        path: 'main',
        loadComponent: () =>
          import('./pages/main/main.component').then(
            (m) => m.WwsAbcAnalysisMainComponent
          ),
      },
      {
        path: 'segment/:segment',
        providers: [AbcAnalysisProductDetailService],
        loadComponent: () =>
          import('./pages/segment-details/segment-details.component').then(
            (m) => m.WwsAbcAnalysisSegmentDetailsComponent
          ),
      },
    ],
  },
];
